module.exports = __webpack_public_path__ + "img/bastao.09be73a2.jpeg";